

































import { IChatRoomItem } from "@/api/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ActionSheet, Toast } from "vant";
import request from "@/api/index";
import { copy } from "@/common/utils";
import { needToken } from "@/common/decorator";
import Native from "@/common/Native";
@Component({
  components: {
    [ActionSheet.name]: ActionSheet
  }
})
export default class ChatRoomItem extends Vue {
  @Prop()
  item!: IChatRoomItem;
  show = false;
  actions = [{ name: "复制" }, { name: "回复" }];

  get zanIcon() {
    if (this.item.isPraise) {
      return require("../assets/image/聊天点赞（已点赞）@2x.png");
    } else {
      return require("../assets/image/聊天点赞@2x.png");
    }
  }

  @needToken(true)
  async doPraise() {
    if (this.item.isPraise) return;
    const result = await request.doPraise(
      this.item.replyUserId,
      this.$store.state.detail!.title,
      this.item.id + "",
      1,
      1
    );
    if (result.data) {
      this.$emit("do-praise", this.item.id, 2);
    }
  }

  select(action: { name: string }) {
    switch (action.name) {
      case "复制":
        if (copy(this.item.content)) {
          Toast("复制成功");
        } else {
          Toast("复制失败");
        }
        break;
      case "回复":
        this.openComment();
        break;
    }
  }

  @needToken(true)
  openComment() {
    Native.openComment({
      sourceType: this.item.sourceType,
      id: this.$store.state.infoClassifyId,
      replyId: this.item.id + "",
      passiveReplyName: this.item.passiveReplyName ?? "",
      passiveReplyId: this.item.passiveReplyId ?? ""
    });
  }
}
